import BgIcon from 'components/atoms/icons/condition-filter-bg.svg?react';
import classNames from 'classnames';
import BaseSpinWrapper from 'components/atoms/base-spin-wrapper';
import { memo, type FC } from 'react';

import s from './styles.module.scss';
import { useButtons } from './use-buttons';

const OverviewDashboardStatusCountFilter: FC = () => {
  const { buttons, isLoading } = useButtons();

  return (
    <BaseSpinWrapper spinning={isLoading}>
      <div className={s.wrapper}>
        {buttons.map(({ active, bgColor, count, status, label, onClick }) => {
          return (
            <button
              className={classNames(s.item, { [s.active]: active })}
              onClick={onClick}
              key={label}
              data-status={status}
            >
              <p className={s.title}>{label}</p>
              <p className={s.count}>{count}</p>
              <BgIcon className={s.bg} color={bgColor} />
            </button>
          );
        })}
      </div>
    </BaseSpinWrapper>
  );
};
export default memo(OverviewDashboardStatusCountFilter);
